import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Resource from 'models/ImpactPlan/Resource';
import { byId } from 'store/utils/sortFunctions';

import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: { byId: {}, bySystem: {} },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.RESOURCES_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: {
            byId: action.payload.results.reduce(
              (obj, resource) => ({
                ...obj,
                [resource.id]: new Resource(resource),
              }),
              state.get('data').get('byId')
            ),
            bySystem: state
              .get('data')
              .get('bySystem')
              .set(
                String(action.payload.system),
                fromJS(action.payload.results.map(resource => new Resource(resource)).sort(byId))
              ),
          },
        })
      );
    case types.RESOURCE_FETCH_SUCCEEDED:
    case types.RESOURCE_CREATE_SUCCEEDED:
    case types.RESOURCE_UPDATE_SUCCEEDED:
      return (() => {
        const systemId = String(action.payload.system);
        const systemResources = state
          .get('data')
          .get('bySystem')
          .get(systemId, new List())
          .filter(resource => resource.id !== action.payload.id)
          .push(new Resource(action.payload))
          .sort(byId);
        return state.merge(
          reduxHelper.applyReceiveInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(String(action.payload.id), new Resource(action.payload)),
              bySystem: state.get('data').get('bySystem').set(systemId, systemResources),
            },
          })
        );
      })();
    case types.RESOURCE_FETCH:
    case types.RESOURCE_CREATE:
    case types.RESOURCE_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.RESOURCE_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(String(action.payload.id)),
            bySystem: state
              .get('data')
              .get('bySystem')
              .set(
                String(action.payload.system),
                state
                  .get('data')
                  .get('bySystem')
                  .get(String(action.payload.system), new List())
                  .filter(resource => resource.id !== action.payload.id)
              ),
          },
        })
      );
    case types.RESOURCE_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.RESOURCE_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.RESOURCE_FETCH_FAILED:
    case types.RESOURCES_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
